import { GrowthBook } from '@growthbook/growthbook-react'
import { nanoid } from 'nanoid'

export const growthbookFeatures = {
  BLACK_FRIDAY: 'black-friday-2024',
  EXIT_INTENT_MODAL: 'exit-intent-modal',
  PROMO_OFFER: 'promo-offer',
  YEARLY_OFFER: 'yearly-offer',
  SEO_DAY_YEARLY_OFFER: 'seo-day-yearly-offer',
  NEW_CHECKOUT_PLAN_SELECTION_V2: 'new-checkout-plan-selection-v2',
  PAYPAL_DISABLED_REGIONAL: 'paypal-disabled-regional',
  NEW_DASHBOARD_LANDING_PAGE: 'dashboard-landing-page',
  NEW_MONTHLY_PRICE: 'new-monthly-price-v2',
  APPLE_PAY_NEW_CONFIGURATION: 'apple-pay-new-configuration',
  INR_CURRENCY: 'inr-currency',
}

const GROWTHBOOK_USER_ID_KEY = 'gbId'

export const growthBook = new GrowthBook({
  apiHost: 'https://cdn.growthbook.io',
  clientKey: process.env.REACT_APP_GROWTHBOOK_CLIENT_KEY,
  enableDevMode: !process.env.IS_PROD,
  subscribeToChanges: true,
})

export const getGrowthbookUserId = () => {
  let gbUserId = localStorage.getItem(GROWTHBOOK_USER_ID_KEY)
  if (gbUserId) return gbUserId
  gbUserId = nanoid()
  localStorage.setItem(GROWTHBOOK_USER_ID_KEY, gbUserId)
  return gbUserId
}

export default growthBook
